var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E50B20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.544 20.545c.66-.66 1.704-.727 2.44-.166l.19.166L32 29.372l8.826-8.827c.678-.678 1.748-.723 2.478-.136l.151.136c.66.66.727 1.703.148 2.461l-.148.168L34.629 32l8.828 8.826c.677.678.722 1.748.135 2.479l-.136.15c-.66.66-1.703.727-2.46.148l-.169-.148-8.828-8.827-8.824 8.828c-.678.677-1.748.722-2.479.135l-.15-.136c-.66-.66-.727-1.703-.148-2.46l.148-.169L29.37 32l-8.826-8.826c-.677-.678-.722-1.748-.135-2.478l.136-.151z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.205 20.205c.83-.83 2.143-.914 3.07-.209l.025.02.214.188L32 28.693l8.487-8.488c.853-.853 2.2-.91 3.118-.17l.02.016.17.153c.834.833.911 2.147.19 3.093l-.01.013-.18.204L35.307 32l8.488 8.486c.853.853.91 2.2.17 3.119l-.016.02-.154.17c-.833.833-2.147.91-3.092.19l-.014-.01-.203-.18L32 35.306l-8.486 8.488c-.853.853-2.2.91-3.118.17l-.02-.016-.17-.153c-.833-.833-.911-2.147-.19-3.092l.01-.014.18-.203L28.691 32l-8.487-8.487c-.853-.853-.91-2.2-.17-3.119l.016-.02.154-.17zM29.371 32l-8.826 8.826-.148.168c-.579.758-.512 1.801.148 2.461l.15.136c.73.587 1.801.542 2.479-.136l8.825-8.828 8.827 8.828.168.148c.758.578 1.802.512 2.462-.148l.135-.15c.587-.73.542-1.801-.136-2.48L34.629 32l8.828-8.826.147-.167c.579-.759.512-1.802-.148-2.462l-.15-.135c-.73-.588-1.801-.543-2.479.135L32 29.372l-8.826-8.828-.19-.166c-.736-.56-1.78-.494-2.44.166l-.135.151c-.587.73-.542 1.8.136 2.478L29.37 32z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.6baef42be0a9055e39decd5965c8d633.svg";
export { ForwardRef as ReactComponent };